import React from 'react';

const Confetti = () => {
  return (
    <svg width="600" height="224" viewBox="0 0 600 224" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        opacity="0.75"
        x="35.5918"
        y="1.52148"
        width="12.1471"
        height="6.07353"
        transform="rotate(-151 35.5918 1.52148)"
        fill="#DF735B"
      />
      <rect
        opacity="0.83"
        x="203.377"
        y="5.67383"
        width="16.5124"
        height="16.5124"
        rx="8.25621"
        transform="rotate(39 203.377 5.67383)"
        fill="#DF735B"
      />
      <rect
        opacity="0.93"
        x="313.072"
        y="-2.03711"
        width="15.943"
        height="15.943"
        rx="7.97151"
        transform="rotate(163 313.072 -2.03711)"
        fill="#DF735B"
      />
      <rect
        opacity="0.74"
        x="468.402"
        y="6.26562"
        width="15.1838"
        height="7.59191"
        transform="rotate(-23 468.402 6.26562)"
        fill="#DF735B"
      />
      <rect
        opacity="0.71"
        x="591.145"
        y="8.63867"
        width="17.2716"
        height="8.6358"
        transform="rotate(69 591.145 8.63867)"
        fill="#DF735B"
      />
      <rect
        opacity="0.85"
        x="18.3906"
        y="28.1758"
        width="13.0961"
        height="6.54803"
        transform="rotate(-118 18.3906 28.1758)"
        fill="#DF735B"
      />
      <rect
        opacity="0.8"
        x="129.643"
        y="33.6523"
        width="15.0889"
        height="15.0889"
        rx="7.54446"
        transform="rotate(112 129.643 33.6523)"
        fill="#DF735B"
      />
      <rect
        opacity="0.71"
        x="262.689"
        y="59.0176"
        width="10.9608"
        height="10.9608"
        rx="5.48041"
        transform="rotate(-33 262.689 59.0176)"
        fill="#DF735B"
      />
      <rect
        x="345.693"
        y="29.3613"
        width="13.2858"
        height="6.64292"
        transform="rotate(91 345.693 29.3613)"
        fill="#DF735B"
      />
      <rect
        opacity="0.81"
        x="373.537"
        y="64.9492"
        width="9.67969"
        height="9.67969"
        rx="4.83984"
        transform="rotate(-89 373.537 64.9492)"
        fill="#DF735B"
      />
      <rect
        opacity="0.79"
        x="459.506"
        y="43.5957"
        width="8.96795"
        height="8.96795"
        rx="4.48397"
        transform="rotate(17 459.506 43.5957)"
        fill="#DF735B"
      />
      <rect
        opacity="0.86"
        x="588.18"
        y="43.5957"
        width="18.2206"
        height="9.1103"
        transform="rotate(59 588.18 43.5957)"
        fill="#DF735B"
      />
      <rect
        x="58.7363"
        y="86.2773"
        width="15.0889"
        height="15.0889"
        rx="7.54446"
        transform="rotate(-88 58.7363 86.2773)"
        fill="#DF735B"
      />
      <rect
        opacity="0.79"
        x="172.973"
        y="86.9551"
        width="20.4982"
        height="10.2491"
        transform="rotate(101 172.973 86.9551)"
        fill="#DF735B"
      />
      <rect
        opacity="0.83"
        x="334.424"
        y="77.3809"
        width="9.82204"
        height="9.82204"
        rx="4.91102"
        transform="rotate(91 334.424 77.3809)"
        fill="#DF735B"
      />
      <rect
        opacity="0.83"
        x="417.428"
        y="92.7871"
        width="14.2348"
        height="7.11742"
        transform="rotate(51 417.428 92.7871)"
        fill="#DF735B"
      />
      <rect
        opacity="0.74"
        x="490.941"
        y="102.871"
        width="21.4472"
        height="10.7236"
        transform="rotate(165 490.941 102.871)"
        fill="#DF735B"
      />
      <rect
        opacity="0.73"
        x="541.916"
        y="93.9746"
        width="15.3736"
        height="15.3736"
        rx="7.68681"
        transform="rotate(-40 541.916 93.9746)"
        fill="#DF735B"
      />
      <rect
        opacity="0.99"
        x="73.8398"
        y="143.607"
        width="22.7757"
        height="11.3879"
        transform="rotate(-125 73.8398 143.607)"
        fill="#DF735B"
      />
      <rect
        opacity="0.86"
        x="517.037"
        y="165.111"
        width="17.2716"
        height="8.6358"
        transform="rotate(-81 517.037 165.111)"
        fill="#DF735B"
      />
      <rect
        opacity="0.76"
        x="572.758"
        y="134.27"
        width="19.1696"
        height="9.58479"
        transform="rotate(76 572.758 134.27)"
        fill="#DF735B"
      />
      <rect
        x="14.2715"
        y="198.289"
        width="11.5302"
        height="11.5302"
        rx="5.76511"
        transform="rotate(83 14.2715 198.289)"
        fill="#DF735B"
      />
      <rect
        opacity="0.75"
        x="78.2949"
        y="192.357"
        width="15.6583"
        height="15.6583"
        rx="7.82916"
        transform="rotate(153 78.2949 192.357)"
        fill="#DF735B"
      />
      <rect
        opacity="0.79"
        x="451.795"
        y="178.123"
        width="12.8114"
        height="12.8114"
        rx="6.40568"
        transform="rotate(154 451.795 178.123)"
        fill="#DF735B"
      />
      <rect
        opacity="0.91"
        x="548.441"
        y="209.559"
        width="16.5124"
        height="16.5124"
        rx="8.25621"
        transform="rotate(-29 548.441 209.559)"
        fill="#DF735B"
      />
    </svg>
  );
};

export default Confetti;
